var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 10C5.88684 10 4.00742 11.0204 2.81089 12.604C2.55336 12.9448 2.4246 13.1152 2.42881 13.3455C2.43207 13.5235 2.5438 13.7479 2.6838 13.8578C2.86502 14 3.11614 14 3.61838 14H12.3821C12.8843 14 13.1354 14 13.3166 13.8578C13.4567 13.7479 13.5684 13.5235 13.5716 13.3455C13.5759 13.1152 13.4471 12.9448 13.1896 12.604C11.993 11.0204 10.1136 10 8.00023 10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 8C9.65708 8 11.0002 6.65685 11.0002 5C11.0002 3.34315 9.65708 2 8.00023 2C6.34337 2 5.00023 3.34315 5.00023 5C5.00023 6.65685 6.34337 8 8.00023 8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser02);
export default __webpack_public_path__ + "static/media/user-02.6e32986787cfeb07f21b03a468d9e891.svg";
export { ForwardRef as ReactComponent };